<template>
  <div class='tour'>
    <!-- <img src='@/assets/nmLogoTekst2.png'> --><br />
    <h1 class='daytour'>Circle around Korita (through Kuci Gate)</h1>
    <div class='tourPic'>
      <img src='@/assets/daytours/tour2/01.jpg' />
    </div>

    <div>
      <ul class='fa-ul'>
        <li>
          <!-- <span class='fa-li'><i class='fas fa-tree fa-2x'></i></span>  -->
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#tourDescription'
            ><h4 class='titles'>Tour description</h4></a
          >
          <div class='collapse' id='tourDescription'>
            <p class='pasus'>
              The tour named Circle around Korita represents a unique experience
              in almost immediate vicinity of the Capital City. Quick escape
              from urban bustle and getting from almost 0 to approximately 1300
              meters above sea level in just 40 minutes (without stops), is
              indeed a refreshment, especially in the summer.
            </p>
            <p class='pasus'>
              Kuci Mountains are a massif, near higher and broader Prokletije
              extending through a several Balkan countries, with 15 peaks above
              2000 meters high while the Kuci tribe inhabiting the area towards
              the massif is one of the most famous in Montenegro for its
              specific multicultural inheritance, multi-religious and
              multi-national unison.
            </p>
            <p class='pasus'>
              The tour almost enters into Albanian territory and the great part
              of it goes along the very border.
            </p>
            <p class='pasus'>
              The tour encompasses a few interesting lookouts with a view on
              Cijevna canyon around 1000 meters deep as well as the highest
              peaks of Prokletije massif, it goes through Montenegrin villages,
              villages inhabited by Albanian people and temporary shepherds’
              settlements known as katun where the spirit of past times can
              still be felt.
            </p>
            <p class='pasus'>
              We also envisaged an easy stroll to the prettiest lookout which
              lasts around 1 hour and a half in both directions, with minimum
              altitude difference to cross which offers an opportunity to get to
              know in more detail a plateau at 1300 meters above sea level where
              Montenegrin homes from old times hold on proudly and some of them
              still being used occasionally.
            </p>
            <p class='pasus'>
              An important part of the tour is a visit to the remains of an old
              Illyrian town from 3rd century BC as well as a visit to a museum
              of Marko MIljanov, a famous Montenegrin warrior, writer and
              philosopher whose saying about bravery and humanity represents
              perhaps the most glorious expression of ethnic code of
              Montenegrins and their ancient traditional morale.
            </p>
            <p class='pasus'>
              There is one place on this route intended for gourmands and lovers
              of good music, highly recommended for the way of preparing
              traditional meals and the choice of domestic alcohol beverages.
            </p>
            <p class='pasus'>
              Finally, if not tired enough, we will pay a visit to a place where
              a famous battle between Montenegrins and Ottomans took place,
              right before the final liberation, marked by a high obelisk to
              reveal to us some details of the famous event.
            </p>
            <p class='pasus'>
              It is afternoon and we are back in the flatlands of Podgorica.
            </p>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#tourDetails'
            ><h4 class='titles'>Tour details</h4></a
          >
          <div class='collapse' id='tourDetails'>
            <p class='pasus'>Type of tour – Private</p>
            <p class='pasus'>
              Availability - April/May – October/November (depending on weather
              conditions)
            </p>
            <p class='pasus'>Group size – 1-7</p>
            <p class='pasus'>Depature – From Podgorica</p>
            <p class='pasus'>Difficulty – easy</p>
            <p class='pasus'>Duration – 7-10 h</p>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <h4 class='titles'>Highlights</h4>
          <vue-picture-swipe :items='items'></vue-picture-swipe>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#itinerary'
            ><h4 class='titles'>Itinerary</h4></a
          >
          <div class='collapse' id='itinerary'>
            <ul class='square'>
              <li class='pasus'>
                9 a.m. - a pick up at your place of stay or at the place we
                agree upon.
              </li>
              <li class='pasus'>
                After some 15 minutes’ drive we reach the first lookout at 500
                meters above sea level providing a view on Podgorica and partly
                Skadar Lake.
              </li>
              <li class='pasus'>
                After only couple of minutes’ drive we reach the remains of an
                old Illyrian town of Medun. It takes us a short walk to reach
                the top of the hill after which we spend 20 minutes getting to
                know the character and work of the known duke Marko Miljanov as
                well as the folklore details and cultural heritage of Kuci tribe
                and Montenegrins.
              </li>
              <li class='pasus'>
                We continue driving up the slopes of Kuci Mountains for 30
                minutes to reach the plateau known as Kucka Korita.
              </li>
              <li class='pasus'>
                An easy stroll to Grlo Sokolovo lookout takes one hour and
                twenty minutes in both directions.
              </li>
              <li class='pasus'>
                Now it is time to refresh in a nice little inn, after which we
                continue our circle around the massif to reach the next two
                lookouts with a view on Cijevna canyon.
              </li>
              <li class='pasus'>
                Between 2:30 and 3 p.m. we should arrive at our kind hosts who,
                if preferred so, prepare some of the well-known local
                specialties for us or we can just take refreshment and continue
                further with our trip.
              </li>
              <li class='pasus'>
                While descending the mountain we enjoy the view on Skadar Lake,
                driving through villages, to reach Podgorica in the afternoon
                (between 3 p.m. and 6 p.m. depending on whether we have lunch
                and visit a memorial in Fundina).
              </li>
            </ul>
             <div class='tour-time'>
              <p> <i class='fas fa-clock'></i> 1.5 hours</p>
              <p> <i class='fas fa-route'></i> 65 km</p>
            </div>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#prices'
            ><h4 class='titles'>Prices:</h4></a
          >
          <div class='collapse' id='prices'>
            <ul class='square'>
              <li class='pasus'>1 person – 150 eur</li>
              <li class='pasus'>2 persons – 85 eur p/person</li>
              <li class='pasus'>3 persons – 60 eur p/person</li>
              <li class='pasus'>4 persons – 50 eur p/person</li>
              <li class='pasus'>5 persons – 75 eur p/person</li>
              <li class='pasus'>6- persons – 70 eur p/person</li>
              <li class='pasus'>7- persons – 65 eur p/person</li>
            </ul>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#included'
            ><h4 class='titles'>Included in price:</h4></a
          >
          <div class='collapse' id='included'>
            <ul class='square'>
              <li class='pasus'>Driving by car/van</li>
              <li class='pasus'>Bottle of water</li>
              <li class='pasus'>Entrance fee for the museum</li>
              <li class='pasus'>Professional guiding service - English</li>
            </ul>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#info'
            ><h4 class='titles'>Practical info:</h4></a
          >
          <div class='collapse' id='info'>
            <ul class='square'>
              <li class='pasus'>
                We recommend that you carry with you a jacket, a cap,
                sunglasses, some sweets and footwear adequate to conditions in
                the mountain area.
              </li>
              <li class='pasus'>
                - The difference in altitude is 1.300 meters. We start at the
                elevation of 50 meters to reach the highest point at 1350
                meters.
              </li>
            </ul>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#optional'
            ><h4 class='titles'>Optional:</h4></a
          >
          <div class='collapse' id='optional'>
            <ul class='square'>
              <li class='pasus'>Lunch in rural household</li>
              <li class='pasus'>Additional walks during the tour</li>
              <li class='pasus'>
                Itinerary changes as agreed (do not affect the price)
              </li>
              <li class='pasus'>Visit to memorial in Fundina</li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
// import VuePictureSwipe from 'vue-picture-swipe';
export default {
  data () {
    return {
      items: [
        {
          src: require('@/assets/daytours/tour2/01.jpg'),
          thumbnail: require('@/assets/daytours/tour2/01.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/daytours/tour2/02.jpg'),
          thumbnail: require('@/assets/daytours/tour2/02.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/daytours/tour2/04.jpg'),
          thumbnail: require('@/assets/daytours/tour2/04.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/daytours/tour2/05.jpg'),
          thumbnail: require('@/assets/daytours/tour2/05.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/daytours/tour2/07.jpg'),
          thumbnail: require('@/assets/daytours/tour2/07.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/daytours/tour2/08.jpg'),
          thumbnail: require('@/assets/daytours/tour2/08.jpg'),
          w: 0,
          h: 720
        }
      ]
    }
  }
}
</script>

<style scoped>
h1 {
  background-color: rgba(113, 186, 107, 0.9);
  border-radius: 3px;
  padding: 5px;
}
ul.square {
  list-style-type: square;
  text-align: left;
}
ul.none {
  list-style-type: none;
  text-align: left;
}

.tourPic {
  margin-top: 5vh;
  width: 100%;
}
.tourPic img {
  width: 100%;
}
.tour {
  padding-left: 10vw;
  padding-right: 10vw;
  padding-top: 15vh;
}
.pasus {
  text-align: justify;
  color: rgb(43, 42, 42);
}
.row {
  display: flex;
  flex-wrap: wrap;
  padding: 0 4px;
}

.cont {
  position: relative;
  text-align: center;
  color: white;
}
.link {
  text-decoration: none;
}
.daytrips {
  padding-top: 10vw;
}
</style>



// WEBPACK FOOTER //
// src/components/DT2_CircleAroundKorita.vue